import dynamic from 'next/dynamic'

import styles from '@/components/search/search.module.scss'
import { RangeFilterAttributes } from '@/lib/hooks/useFilterResultCounts'
import { filterLabelPrettyName } from '@/lib/utilities/search'
import { Size } from '@/types/system'

const Icon = dynamic(() => import('@/components/styleguide/Icon'))

type CheckboxProps = {
  item:
  | RangeFilterAttributes
  | {
    id: number
    name: string
    displayName?: string
    supporting?: string
  }
  filter: string
  resultCount?: number | undefined
  isSelected: boolean
  valueAttribute: 'id' | 'name'
  type?: 'multi' | 'vehiclePriceTag'
  onChange: (params: {
    type: 'multi' | 'single' | 'vehiclePriceTag'
    filter: string
    value: string | number
  }) => void
  showResultCount?: boolean
  className?: string
}

export const Checkbox = ({
  item,
  valueAttribute,
  filter,
  resultCount,
  isSelected,
  onChange,
  type = 'multi',
  showResultCount = true,
  className,
}: CheckboxProps) => {
  return (
    <button
      className={`${styles.item} ${className}`}
      type="button"
      key={item.name}
      disabled={resultCount === 0}
      onClick={() => {
        onChange({
          type,
          filter,
          value: item[valueAttribute],
        })
      }}
      data-is-selected={isSelected}>
      <span className={styles.label}>
        <span className={styles.name}>
          {filterLabelPrettyName(filter, item.displayName ? item.displayName : item.name)}
        </span>
        {item.supporting && <span className={styles.supporting}>{item.supporting}</span>}
      </span>
      {/*{showResultCount && resultCount && (*/}
      {/*  <span className={styles.count}>{formatWithCommas(resultCount)}</span>*/}
      {/*)}*/}
      <span className={styles.box}>
        <Icon
          name="Check"
          size={Size.Small}
          customClass={styles.check}
        />
      </span>
    </button>
  )
}
